
function Create () { 
    return(
        <>
            {/*
            <!-- =============page banner==================== -->*/}
            <div className="page-banner">
                <div className="container">
                    <div className="page-banner-content">
                        <div className="banner-inner">
                            <h2>Create Item</h2>
                            <div className="page-route">
                                <a href="">Home </a>
                                <p> / Create Item </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/*
            <!-- =============page banner end================ -->*/}
            {/* <!-- ==============profile area========== --> */}
        <div class="profile-area cpt-6">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-12 mb-4">
                        <div class="profile-img-wrapper">
                            <div class="profile-card">
                                <div class="profile-img"><img src="assets/img/inner/18.png" alt="Image not found"/></div>
                            </div>
                            <div class="change-image-area">
                                <div class="form-group">
                                    <input type="file" name="file-7[]" id="file-7" class="inputfile" multiple />
                                    <label for="file-7"><span class="archive-name">Upload File</span></label>
                                </div>

                                <a href="" class="custom-btn"><span>Delate File</span></a>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-9 col-md-12">
                        <h4 class="sm-title mb-3">
                            Choice your Cover image
                        </h4>
                        <div class="row">

                            <div class="col-md-4 mb-4">
                                <div class="profile-image-upload-card">
                                    <div class="form-group">
                                        <input type="file" name="file-7[]" id="file-8" class="inputfile" multiple />
                                        <label for="file-8"><span class="archive-name">Upload File</span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 mb-4">
                                <div class="profile-image-upload-card">
                                    <div class="form-group">
                                        <input type="file" name="file-7[]" id="file-9" class="inputfile" multiple />
                                        <label for="file-9"><span class="archive-name">Upload File</span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 mb-4">
                                <div class="profile-image-upload-card">
                                    <div class="form-group">
                                        <input type="file" name="file-7[]" id="file-10" class="inputfile" multiple />
                                        <label for="file-10"><span class="archive-name">Upload File</span></label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="form-info mt-5">
                            <div class="row">
                                <div class="col-md-6">
                                    <h4 class="sm-title mb-3">
                                        Account Information
                                    </h4>
                                    <div class="mb-3">
                                        <label for="name" class="form-label">Display Name</label>
                                        <input type="text" class="form-control" id="name" placeholder="Display Name" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="url" class="form-label">Custom URL</label>
                                        <input type="text" class="form-control" id="url" placeholder="Custom URL" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="email" class="form-label">Email</label>
                                        <input type="email" class="form-control" id="email" placeholder="Email" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="bio" class="form-label">Bio</label>
                                        <textarea name="" id="" cols="30" class="form-control" rows="5"></textarea>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h4 class="sm-title mb-3">
                                        Your Social media
                                    </h4>
                                    <div class="mb-3">
                                        <label for="facebook" class="form-label">Facebook</label>
                                        <input type="text" class="form-control" id="facebook" placeholder="Facebook" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="Twitter" class="form-label">Twitter</label>
                                        <input type="text" class="form-control" id="Twitter" placeholder="Twitter" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="Instagram" class="form-label">Instagram</label>
                                        <input type="text" class="form-control" id="Instagram" placeholder="Instagram" />
                                    </div>
                                    <div class="mb-3">
                                        <label for="Discord" class="form-label">Discord Username</label>
                                        <input type="Discord" class="form-control" id="Discord" placeholder="Discord Username" />
                                    </div>
                                    <div class="mb-3">
                                        <button class="custom-btn" type="submit"><span>Submit Details</span></button>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* <!-- ==============profile area end========== --> */}
        </>
    ); 
} 

export default Create;